/**
 * xux edit grid widget
 */
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { isNil, map } from 'lodash';
import { IXVIListColumn } from '@shared/types';

import { xviFrameworkComponents } from '../../xvi-grid/cell-helpers/index';
import { XuxGridCustomComponent } from '@components/xux-grid-custom';
import { XuxEditGridComponent } from '@components/xux/xux-edit-grid/xux-edit-grid-widget.component';

const frameworkComponents = {};
xviFrameworkComponents.forEach(
  (element) => (frameworkComponents[element.key] = element),
);

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xux-edit-grid-custom',
  templateUrl: './xux-edit-grid-widget-custom.component.html',
  styleUrls: ['./xux-edit-grid-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class XuxEditGridCustomComponent
  extends XuxEditGridComponent
  implements OnInit, OnDestroy
{
  @ViewChild(XuxGridCustomComponent, { static: true })
  // @ts-ignore
  public xuxGridComponent: XuxGridCustomComponent;

  public handleGridColumns(): void {
    if (!isNil(this.widgetData?.columns)) {
      this.gridColumns = this.initialColumnDefs(this.widgetData?.columns);
    }

    this.subscriptions.push(
      this.widgetData?.columnsObs?.subscribe((newColumns) => {
        // update grid columns
        const columnDefs = this.initialColumnDefs(newColumns);
        this.gridColumns = columnDefs;
        this.resetGridColumns(columnDefs);
      }),
    );
  }

  public selectTheDisabledClass(): string {
    if (this.disabled && this.rowSelectableWhenDisabled) {
      return 'canSelectRowWhenDisabled';
    }
    if (this.disabled) {
      return 'disabled';
    }

    return '';
  }

  private initialColumnDefs(columns: IXVIListColumn[]): IXVIListColumn[] {
    const newColumns = map(columns, (column: IXVIListColumn) => {
      if (isNil(column.editable)) {
        column.editable = false;
      }
      if (column.editable) {
        column.suppressKeyboardEvent = this.suppressKeyboardEvent;
      }

      column.autoHeight = true;

      return column;
    });

    return this.i18nService.translateTextInColumns(newColumns);
  }
}
